import React from "react";
import { useTranslation } from "react-i18next";
import Hero from "src/components/Hero/Hero";
import TitleSection from "src/components/TitleSection/TitleSection";
import ReactMarkdown from "react-markdown";
import styled from "styled-components";
import { Col, Row } from "react-bootstrap";
import TournamentSubtabsContent from "src/pages/poker/tournaments/TournamentSubtabsContent";
import TournamentSectionalTabs from "src/components/SectionalTabs/TournamentSectionalTabs";
import { useHomepage } from "src/context/homepage/homepage.provider";
import { LuAlarmClock } from "react-icons/lu";
import EventFinished from "src/components/EventFinished";
import useResponsiveImageUrl from "src/utils/useResponsiveImageUrl";

const WinAMillion2025 = () => {
  const { i18n, t } = useTranslation();
  const { tournamentsSubtabs } = useHomepage();
  const sectionalTabsContent = t(
    "winAMillion2025.content.sectionalTabsContent",
    { returnObjects: true }
  );

  const dynamicSubTabs = sectionalTabsContent[`subTab${tournamentsSubtabs}`];

  return (
    <Div>
      <EventFinished scheduleKeyName="winAMillion2025" eventType="promotion" />
      <Hero
        // image={t("winAMillion2025.hero.image")}
        bgImage={`promotions/gaming-machines/win-a-million-2025/header-hero-image-2400x800px-${i18n.language}.jpg`}
        imageAlt={t("winAMillion2025.hero.imageAlt")}
        fluidImage={true}
      />
      <MainContentSection>
        <container-div>
          <TitleSection
            as={"h2"}
            title={t("winAMillion2025.content.title")}
            text={t("winAMillion2025.content.text")}
            borderColor="none"
          />
          <Row className="g-4 mb-4">
            <Col xs={12} md={6}>
              <ContentCard
                bgImage={useResponsiveImageUrl(
                  "promotions/gaming-machines/win-a-million-2025/sparkle-box.png"
                )}
              >
                <CardHeader>
                  {t("winAMillion2025.content.drawAndPlayDates.title")}
                </CardHeader>
                <CardContent>
                  <ReactMarkdown>
                    {t("winAMillion2025.content.drawAndPlayDates.text")}
                  </ReactMarkdown>
                </CardContent>
              </ContentCard>
            </Col>
            <Col xs={12} md={6}>
              <ContentCard
                bgImage={useResponsiveImageUrl(
                  "promotions/gaming-machines/win-a-million-2025/sparkle-box.png"
                )}
              >
                <CardHeader>
                  {t("winAMillion2025.content.howItWorks.title")}
                </CardHeader>
                <CardContent>
                  <ReactMarkdown>
                    {t("winAMillion2025.content.howItWorks.text")}
                  </ReactMarkdown>
                </CardContent>
              </ContentCard>
            </Col>
          </Row>
          <Row className="g-4 mb-4">
            <Col>
              <ContentCard>
                <CardHeader>
                  {t("winAMillion2025.content.earnEntries.title")}
                </CardHeader>
                <CardContent>
                  <ReactMarkdown>
                    {t("winAMillion2025.content.earnEntries.text")}
                  </ReactMarkdown>
                </CardContent>
              </ContentCard>
            </Col>
          </Row>
          <Row className="g-4 mb-1">
            <Col>
              <ContentCard>
                <CardHeader>
                  {t("winAMillion2025.content.multiplierDays.title")}
                </CardHeader>
                <CardContent>
                  <ReactMarkdown>
                    {t("winAMillion2025.content.multiplierDays.text")}
                  </ReactMarkdown>
                </CardContent>
              </ContentCard>
            </Col>
          </Row>
        </container-div>
      </MainContentSection>
      <Hero
        bgImage="promotions/gaming-machines/win-a-million-2025/WAM-Scavenger-hunt-header-hero-image-2400x800px.jpg"
        image={`promotions/gaming-machines/win-a-million-2025/WAM-Scavenger-hint-logo-2400x2400px-${i18n.language.toUpperCase()}.png`}
        imageAlt="Win a Million Scavenger Hunt Logo"
        className="scavenger-hero"
        fluidImage={false}
      />
      <container-div className="scavenger-hunt-content">
        <TitleSection
          as={"h2"}
          title={t("winAMillion2025.content.scavengerHunt.title")}
          text={t("winAMillion2025.content.scavengerHunt.text")}
          borderColor="none"
        />
      </container-div>
      <container-div>
        <div className="tabContent my-4 pb-4">
          <TournamentSectionalTabs
            subTabs={t("winAMillion2025.content.sectionalTabs", {
              returnObjects: true,
            })}
          />
          <TournamentSubtabsContent tournamentContent={dynamicSubTabs} />
        </div>
      </container-div>
    </Div>
  );
};
const Div = styled.div`
  --topspacing: 110px;
  --gradientheight: 40px;

  background-color: var(--lightblack);
  color: var(--white);
  text-align: center;
  overflow-x: hidden;
  height: auto;
  padding-bottom: 40px;
  .scavenger-hero {
    .hero_image_container {
      min-height: unset;
      overflow: hidden;
      img {
        clip-path: inset(25% 0 0 0);
        transform: scale(1.33) translateY(-18.75%);
        /* Scale up by 1.33 (1/0.75) and shift up to compensate for the clipped space */
      }
    }
  }
  .hero_text_container {
    display: none;
    padding: 0;
  }
  .hero_image_container {
    padding: 20px;
    min-height: 600px;
    @media (max-width: 768px) {
      min-height: 300px;
    }
    /* img {
      max-height: 500px;
    } */
  }
  .hero_container.fluid {
    min-height: 440px;
    @media (min-width: 768px) and (max-width: 991px) {
      --topspacing: 40px;
      --gradientheight: 20px;
    }
    @media (max-width: 768px) {
      min-height: 150px;
    }
    @media (min-width: 768px) {
      top: var(--topspacing);
      margin-bottom: var(--topspacing);
      /*
        This gives a black bar a the top, behind the nav
        and 40px of gradient overlying the banner image
      */
      &:before {
        background: linear-gradient(
          to bottom,
          rgba(0, 0, 0, 1) 0%,
          rgba(0, 0, 0, 1) 71.43%,
          rgba(0, 0, 0, 0) 100%
        );
        content: "";
        height: calc(var(--topspacing) + var(--gradientheight));
        top: calc(-1 * var(--topspacing));
        position: relative;
      }
    }
  }
  .title-section {
    h2 {
      text-transform: uppercase;
      color: #f0cb43;
    }
    p {
      max-width: unset;
    }
  }
  p,
  li {
    strong {
      /* color: #f0cb43; */
    }
  }
  li {
    padding-bottom: 0.75rem;
    ul li {
      padding-bottom: 0;
      margin-bottom: 0;
    }
  }
  .how-it-works li {
    list-style: none;
    &::before {
      content: "•";
      /* color: #f0cb43; */
      font-weight: bold;
      display: inline-block;
      width: 1em;
      margin-right: 0.5em;
    }
  }
  div.periods {
    text-align: center;
    p {
      font-size: 16px;
      strong {
        color: unset;
      }
    }
    svg {
      margin: 20px 0 10px;
      color: #f0cb43;
      font-size: 40px;
    }
  }
  .left {
    text-align: left;
  }

  .sectional-tournament-tabs {
    justify-content: space-around;
    margin: 20px;
    width: calc(100% - 40px);
    button {
      min-height: unset;
      padding: 0.8rem;
      &.active {
        background-color: var(--white);
        color: var(--mutedred);
      }
      &:hover {
        background-color: var(--white);
        color: var(--mutedred);
      }
    }
    @media (min-width: 768px) {
      button {
        max-width: 24%;
      }
    }
  }
  a {
    /* color: #f0cb43; */
    &:hover {
      /* border-bottom: 1px solid #f0cb43; */
    }
  }
  .tabContent {
    background-color: var(--black);
  }

  .scavenger-hunt-content {
    padding: 3rem 1rem;

    .title-section {
      margin-bottom: 2rem;
    }

    a {
      display: inline-block;
      margin: 0 auto;
    }

    @media (max-width: 768px) {
      padding: 2rem 1rem;
    }
  }
`;

const MainContentSection = styled.div`
  background-color: var(--lightblack);
  padding: 2rem 0 0;

  container-div {
    max-width: 1200px;
  }

  .title-section {
    margin-bottom: 2rem;
  }
`;

const ContentCard = styled.div`
  background: url(${(props) => props.bgImage}) no-repeat;
  background-size: cover;
  background-position: 70% center;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const CardHeader = styled.div`
  background: linear-gradient(135deg, #c9a961 0%, #f4e4a6 50%, #c9a961 100%);
  color: var(--black);
  padding: 0.2rem 1.5rem;
  font-size: 1.75rem;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 0.05em;

  @media (max-width: 768px) {
    font-size: 1.1rem;
    padding: 0.875rem 1rem;
  }
`;

const CardContent = styled.div`
  padding: 1.75rem 2rem;
  color: var(--white);
  flex: 1;
  font-size: 1.05rem;

  p {
    margin-bottom: 0.875rem;
    line-height: 1.7;

    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    font-weight: 600;
  }

  ul,
  ol {
    margin: 0.75rem 0;
    padding-left: 1.5rem;

    li {
      margin-bottom: 0.65rem;
      line-height: 1.7;
    }
  }

  @media (max-width: 768px) {
    padding: 1.25rem;
    font-size: 0.95rem;
  }
`;

export default WinAMillion2025;
